import { Tooltip } from '@analog/ui/src';
import { Card, SearchBox, Switches, Table } from 'components';
import { Skeleton } from 'components/Skeleton';
import { arrayOfSize, SortColumnsValidators } from 'utils';

import { StakingChart, StakingChartStatType, StakingStats, StakingStatType } from './components';
import { useValidatorList } from './useValidatorList';

const ValidatorList = () => {
  const {
    PageController,
    isLoading,
    validatorsData,
    pageSize,
    onSort,
    selectedTab,
    setSelectedTab,
    sortOrder,
    stakingTelemetry,
    isStakingTelemetry,
    handleDownload,
    VALIDATOR_COLUMNS,
    tabs,
  } = useValidatorList();

  return (
    <>
      <div className="flex flex-col gap-4 md:gap-8">
        <SearchBox defaultSearchType={'All'} />
      </div>
      <Skeleton.Provider isLoading={isStakingTelemetry}>
        <div className="sm:flex justify-between mt-10 gap-5">
          <StakingStats
            telemetryData={stakingTelemetry?.stakingTelemetry as unknown as StakingStatType}
          />
          <StakingChart
            telemetryData={stakingTelemetry?.stakingTelemetry as unknown as StakingChartStatType}
          />
        </div>
      </Skeleton.Provider>
      <div className="mt-8 md:mt-[60px]">
        <Card extraClasses="flex gap-4 md:gap-[22px] flex-col">
          <div className="flex items-center justify-between gap-5 md:gap-0">
            <span className="text-white text-xl">Validator</span>
            <Switches tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
          </div>
          <Table
            isLoading={isLoading}
            columns={VALIDATOR_COLUMNS}
            hasHeader
            data={isLoading ? arrayOfSize(pageSize) : validatorsData}
            classNames={{
              row: 'grid gap-x-2 grid-cols-2 md:grid-cols-[minmax(220px,22%)_minmax(160px,22%)_minmax(160px,22%)_minmax(70px,15%)_minmax(120px,13%)_minmax(120px,13%)_minmax(120px,8%)]',
              columns: 'justify-start',
            }}
            sortOptions={SortColumnsValidators}
            onSort={onSort}
            sortOrder={sortOrder}
          />
          {(isLoading || !!validatorsData?.length) && (
            <PageController onDownload={handleDownload} />
          )}
        </Card>
      </div>
      <Tooltip id={'hash'} />
    </>
  );
};

export default ValidatorList;
